<div class="ftc-card">
  <div class="ftc-header">
    <div class="ftc-text">
      <span class="ftc-title">{{ title }}</span>
      <span class="ftc-description">{{ description }}</span>
    </div>
    <div class="form-check form-switch ftc-toggle">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        [id]="'ftc-toggle-' + title"
        [(ngModel)]="enabled"
        (ngModelChange)="onToggle()"
        [attr.aria-label]="title"
        [attr.aria-checked]="enabled"
      />
    </div>
  </div>

  <div class="ftc-body" *ngIf="enabled">
    <ng-content></ng-content>
  </div>
</div>
